const CHART_ORDERBOOK_SECTION_TABS = {
  CHART: 'chart',
  ORDERBOOK: 'orderbook',
  RECENT_TRADES: 'recentTrades',
} as const;

export { CHART_ORDERBOOK_SECTION_TABS };
